import { useContext } from "react";
import { ModalSettingContext } from "../../index";
import { TimePicker } from 'antd';
import dayjs from 'dayjs';
import common from '../common.module.css';
import { getInitialState } from "../../initState";
import { selectProfile } from "@store/profile.reducer";
import { useSelector } from "react-redux";
import { useAddAlert } from "@/hooks/useAddAlert";

const { RangePicker } = TimePicker;

export const Time = () => {
    const { state, setFieldInState } = useContext(ModalSettingContext);
    const profile = useSelector(selectProfile);
    const addAlert = useAddAlert()
    
    const handleTimeChange = (times, timeStrings) => {
        if (!times) {
            setFieldInState({ field: 'time', value:  getInitialState({profile}).time});
            return;
        }

        const [start, end] = times;
        
        // Проверяем, что время окончания не раньше времени начала
        if (end.isBefore(start)) {
            addAlert({title:'Ошибка', text: 'Время окончания не может быть раньше времени начала', type: 'error'})
            return;
        }
        
        updateTime(timeStrings);
    };

    const updateTime = (timeStrings) => {
        setFieldInState({   
            field: 'time', 
            value: {
                start_time: timeStrings[0], 
                end_time: timeStrings[1]
            }
        });
    };

    const handleBlur = (e) => {
        try {
            const inputValues = e.target.value.split(' - ');
            if (inputValues.length === 2) {
                const start = dayjs(inputValues[0], 'HH:mm', true);
                const end = dayjs(inputValues[1], 'HH:mm', true);
                
                if (start.isValid() && end.isValid()) {
                    if (end.isBefore(start)) {
                        addAlert({title:'Ошибка', text: 'Время окончания не может быть раньше времени начала', type: 'error'});
                    } else {
                        updateTime(inputValues);
                    }
                }
            }
        } catch (error) {
            console.error('Error parsing manual time input:', error);
        }
    };

    return (
        <RangePicker
            value={[
                dayjs(state.time.start_time, 'HH:mm'),
                dayjs(state.time.end_time, 'HH:mm')
            ]}
            onChange={handleTimeChange}
            onBlur={handleBlur}
            onOk={handleTimeChange}
            format="HH:mm"
            className={common.antd}
            order={false}
            inputReadOnly={false} // Разрешаем ручной ввод
        />
    );
};